// extracted by mini-css-extract-plugin
module.exports = {"container":"AudioControls-module--container--DddSw","trackTitle":"AudioControls-module--trackTitle--3vAQC","controls":"AudioControls-module--controls--IWMHb"};